import {setPageConfig,setNowTabPageCongfig,clearRowDataDeep,getMyColums} from "@/tools/table-drag.js";
let cacheSize = parseInt(localStorage.getItem('pageSize'));
import {getRandomString,isNotEmpty} from "@/tools/utils";
import useDialogPluginComponent from 'quasar/src/composables/use-dialog-plugin-component.js';;
const tableData = {};
const user = JSON.parse(localStorage.getItem('userBase'));
const usedOms = user&&user.used_oms?true:false;
const pageConfig = {
    resetPage:null,
    loading:false,
    tableName:'quotation',
    height:'',
    pageKey:getRandomString(),
    top_tools:{
        "HEADER":[
            {unpem:!usedOms, index: 3, name: ['使用OMS单据生成采购订单'], icon: 'fas fa-file-invoice', check_lines: 0, on_click: [], sign: 'generatePurchaseOrderOms', },
            { index: 2, name: ['生成采购订单'], icon: 'fas fa-tasks', check_lines: 0, on_click: [], sign: 'generatePurchaseOrder', },
            // { index: 0, name: ['手动更新物料'], icon: 'fas fa-sync-alt', check_lines: 0, on_click: [], sign: 'updateErpMaterial', },
            { index: 0, name: ['导出'], icon: 'fas fa-file-excel', check_lines: 0, on_click: [], sign: 'exportExcel', },
            { index: 1, name: ['清除报价单中生成标志'], icon: 'fas fa-hand-paper', check_lines: 0, on_click: [], sign: 'clearSign', },
        ]
    },
    pageConfig:{},
    pageConfigTree:[],
    dialogPage:{
        colseDialogFun:null,
        isPushIng:false,
        isFalsePagination:['DATA'],
        resetPage:null,
        loading:false,
        tableName:'proforma-invoice-send-Dialog',
        height:'',
        pageKey:getRandomString(),
        getPageKey:'quotaion/getPushDataPageKey',
        top_tools:{},
        pageConfig:{},
        pageConfigTree:[],
    }
}
const state = () => ({
    quotaion: Object.assign({}, tableData,pageConfig),
})
const getters = {
    getPageConfig: state => state.quotaion.pageConfig,
    getPageConfigTree: state => state.quotaion.pageConfigTree,
    getPageKey:state => state.quotaion.pageKey,
    getPushDataDialog:state => state.quotaion.dialogPage,
    getPushDataPageKey:state => state.quotaion.dialogPage.pageKey,
}
const mutations ={
    resetUnpemFun(state, data){
        state.quotaion.top_tools.HEADER.forEach((item,index)=>{
            if(item.sign == 'generatePurchaseOrderOms'){
                const user = JSON.parse(localStorage.getItem('userBase'));
                const usedOms = user&&user.used_oms?true:false;
                item.unpem = !usedOms;
            }
        })
    },
    setRestPageFun(state, data){
        state.quotaion.resetPage = data;
    },
    setLoading(state, data){
        state.quotaion.loading = data;
        if(isNotEmpty(state.quotaion.pageConfig)){
            Object.keys(state.quotaion.pageConfig).forEach((key,index)=>{
                state.quotaion.pageConfig[key].loading = data;
            })
        }
    },
    setPageConfig(state, data){
        state.quotaion.pageConfig = data.pageConfig;
        state.quotaion.pageConfigTree = data.allArrData;
        state.quotaion.pageKey = getRandomString();
        if(isNotEmpty(state.quotaion.pageConfig)){
            Object.keys(state.quotaion.pageConfig).forEach((key,index)=>{
                state.quotaion.pageConfig[key].height = state.quotaion.height
            })
        }
    },
    setPushDialogConfig(state, data){
        state.quotaion.dialogPage.pageConfig = data.pageConfig;
        state.quotaion.dialogPage.pageConfigTree = data.allArrData;
        state.quotaion.dialogPage.pageKey = getRandomString();
        if(isNotEmpty(state.quotaion.dialogPage.pageConfig)){
            Object.keys(state.quotaion.dialogPage.pageConfig).forEach((key,index)=>{
                state.quotaion.dialogPage.pageConfig[key].height = state.quotaion.height
            })
        }
    },
    setPushDialogList(state, data){
        state.quotaion.dialogPage.pageConfig[data.obj].data = data.data;
        state.quotaion.dialogPage.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    setList(state, data) {
        console.log(state.quotaion.pageConfig,' state.quotaion.pageConfig state.quotaion.pageConfig');
        state.quotaion.pageConfig[data.obj].data = data.data;
        state.quotaion.pageConfig[data.obj].pagination.rowsNumber = data.count;
    },
    ['refreshTableHeight'](state, data) {
        state.quotaion.height = (data-50) + 'px';
        if(isNotEmpty(state.quotaion.pageConfig)){
            Object.keys(state.quotaion.pageConfig).forEach((key,index)=>{
                state.quotaion.pageConfig[key].height = state.quotaion.height;
            })
        }
        state.quotaion.dialogPage.height = (data-50) + 'px';
        if(isNotEmpty(state.quotaion.dialogPage.pageConfig)){
            Object.keys(state.quotaion.dialogPage.pageConfig).forEach((key,index)=>{
                state.quotaion.dialogPage.pageConfig[key].height = state.quotaion.height
            })
        }
    },
    ['clearData'](state, data) {
        clearRowDataDeep({tabName:data.tabName,pageConfig:state.quotaion.pageConfig,pageConfigTree:state.quotaion.pageConfigTree});
    }
}
const actions = {
    ['clear-purchase']({ state, dispatch, rootState ,commit}, payload) {
        if(state.quotaion.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__quotation_make_purchase_tag", message: {
                order_list: [payload.VBELN]
            }, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['make-purchase']({ state, dispatch, rootState ,commit}, payload) {
        if(state.quotaion.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__quotation_make_purchase", message: {
                order_list: [payload.VBELN]
            }, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    async ['fetch-list']({ state, dispatch, rootState ,commit}, payload) {
        if(state.quotaion.loading) return;
        commit('setLoading',true);
        let msg = { command: "get_client__quotation", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
    },
    ['make_purchase_return']({ state, commit,dispatch }, payload) {
        console.log(payload);
        if (payload.success) {
            dispatch('response/success-tip', {message: '操作成功:'+payload.data}, {root: true})
        }
        commit('setLoading',false);
        state.quotaion.resetPage({});
    },
    ['make_purchase_tag_return']({ state, commit,dispatch }, payload) {
        console.log(payload);
        commit('setLoading',false);
        state.quotaion.resetPage({});
        if (payload.success) {
            dispatch('response/success-tip', {message: '操作成功:'+payload.data}, {root: true})
        }
        console.log(payload,'payload');
    },
    async ['return_list']({ state, commit }, payload) {
        console.log(payload,'payloadpayloadpayload');
        commit('setLoading',false);
        if (payload.success) {
            if(!isNotEmpty(state.quotaion.pageConfigTree)){//生成 页面列配置 并处理成需要的结构
                let pageData = setPageConfig({pageData:payload.data.objs,tableName:state.quotaion.tableName,top_tools:state.quotaion.top_tools});
                commit('setPageConfig',pageData);
            }
            let myCoums = await getMyColums({name:state.quotaion.tableName+'-'+payload.data.obj});//获取偏好
            setNowTabPageCongfig({pageConfig:state.quotaion.pageConfig[payload.data.obj],myColums:myCoums})//设置为自己的偏好
            commit('setList',payload.data);
        }
    },
    ['return_export']({ state, commit }, payload) {
        if(payload.success){
            window.open(process.env.VUE_APP_APIHOST+'/'+payload.data);
        }
    },
    async['export_excel']({ state, dispatch, rootState }, payload) {
        let msg = { command: "get_client__quotation_export_excel", message: payload, to: "client" }
        dispatch('channel/socket_send', msg, { root: true })
        dispatch('response/info-tip', { message: '正在导出' }, { root: true })
    },
    async['return_inventory__export']({ state, dispatch, rootState }, payload) {
        if (payload.success) {
            window.open(payload.data, '_blank')
            dispatch('response/success-tip', { message: '导出成功' }, { root: true })
        }
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
